import React from 'react';
import PropTypes from 'prop-types';
import { purchaseQueries } from '../../graphql/queries';
import BBQuery from './BBQuery.js';

// uses render props pattern - https://reactjs.org/docs/render-props.html
// in this case prop is 'children' not 'render' but its the same concept

class PurchaseById extends React.Component {
  render () {
    const { children, id } = this.props;
    return (
      <BBQuery
        query={purchaseQueries.PurchaseById(id)}
        showLoader
      >
        {data => {
          return children(data.purchaseById);
        }}
      </BBQuery>
    );
  }
}

PurchaseById.propTypes = {
  children: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired
};

export default PurchaseById;
